import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput, MultiSelectInput } from '../forms';
import { SchedulerReferenceStore, schedulerReferenceActions } from '../../../scheduler/store/schedulerReferenceStore';

type PostSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    schedulerReferenceStore?: SchedulerReferenceStore,
    partnerOfficeId?: string, // если параметр не передан, то Включаем disable на компонент
    multiSelect?: boolean,
  };

const PostSelector = (props: PostSelectorProps) => {
  const {
    schedulerReferenceStore,
    partnerOfficeId,
    multiSelect,
    name,
    label,
    placeholder,
    ...rest
  } = props;

  const { postsForSelector, getPostForSelectorByRequest } = schedulerReferenceStore;

  const [loading, setLoading] = useState(false);

  /* const getFilteredData = () => {
    let serviceData = onlyPartnerService ? partnerServices : services;
    if (typeof filter === 'function') {
      serviceData = serviceData.filter(filter);
    }
    if (onlyStationary) { serviceData = serviceData.filter(v => v.stationary); }
    if (onlyNoStationary) { serviceData = serviceData.filter(v => !v.stationary); }
    return serviceData;
  }; */

  const loadData = () => {
    if (partnerOfficeId) {
      if (getPostForSelectorByRequest?.partnerOfficeId !== partnerOfficeId) {
        setLoading(true);
        schedulerReferenceActions.getPostsForSelector({ partnerOfficeId, showDeleted: false })
          .finally(() => setLoading(false));
      }
    } else {
      schedulerReferenceActions.clearPostsForSelector();
    }
  };

  useComponentDidMount(() => {
    loadData();
  });

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerOfficeId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ postsForSelector }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          disabled={ rest.disabled || (!partnerOfficeId) }
          name={ name }
          label={ label }
          placeholder = { placeholder }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ postsForSelector }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          disabled={ rest.disabled || (!partnerOfficeId) }
          name={ name }
          label= { label }
          placeholder = { placeholder }
          sort
        />
      )

  );
};

export default inject('schedulerReferenceStore')(observer(PostSelector));
